/* eslint-disable */
export default function organizationValidation(e, msgContainer, key) {
    msgContainer[key] = [];
    msgContainer['isError'] = false;
    let insertedName = e.target.value;
    // let res1 =  /^[a-zA-Z()_ \-\[\]'\\|,.\/]*$/.test(insertedName);
    let res1 =  /^[a-zA-Z0-9\s]*$/.test(insertedName);
    let res2 =  /\S+@\S+\.\S+/.test(insertedName);
    let res3 = /\S+\.\S+/.test(insertedName);
    if(insertedName.length < 1){
        msgContainer[key].push('*Required');
        msgContainer['isError'] = true;
    }else if(key === 'name' && !res1){
        msgContainer[key].push('*Name Must be Alpha With Space Only');
        msgContainer['isError'] = true;
    }else if(key === 'user_email' && !res2){
        msgContainer[key].push('*Admin email must be valid email address');
        msgContainer['isError'] = true;
    }else if(key === 'domain' && !res3){
        msgContainer[key].push('*Domain Must be Valid Domain');
        msgContainer['isError'] = true;
    }
}
